import React from 'react'

const MonthEnd = () => {
  return (
    <div>ABCD</div>
  )
}

export default MonthEnd